<div class="widget-icon" cdkDrag [cdkDragData]="data">
    <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">
        {{data.icon}}
    </mat-icon>
    <div class="mdc-card">
        <h4>Customizable Settings for Date validation</h4>
        <p>Date</p>
        <label for="left">Start Date</label>
        <select id="left" [(ngModel)]="left" name="left" (ngModelChange)="onSelected($event)">
            <option *ngFor="let field of fields" [value]="field">{{field}}</option>
        </select>

        <label for="condition">Start Date</label>
        <select id="condition" [(ngModel)]="condition" name="condition" (ngModelChange)="onSelected($event)">
            <option>&lt;</option>
            <option>&gt;</option>
            <option>&lt;=</option>
            <option>&gt;=</option>
            <option>=</option>
        </select>

        <label for="right" >Start Date</label>
        <select id="right" [(ngModel)]="right" name="right" (ngModelChange)="onSelected($event)">
            <option *ngFor="let field of fields" [value]="field">{{field}}</option>
        </select>            
    </div>
</div>